module.exports = __webpack_public_path__ + "img/4.0cf9e857.jpg";